import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Loader from '../spinner';
import css from './index.scss';
import SignInCardsEmptyState from './modals/blank-state';
import SignInCardsDownloadView from './pages/sign-in-cards';

const SignInCards = (props) => {
    const { isClassroomsLoaded, isTeachersLoaded, filteredClassrooms } = props;

    const classesWithStudents = filteredClassrooms.filter(classes => classes.studentsCount).length;

    const finalView = (isClassroomsLoaded && isTeachersLoaded)
        ? (<div>
            <SignInCardsEmptyState
                classesWithStudents={classesWithStudents}
                {...props} />
            <SignInCardsDownloadView {...props} />
        </div>) : (<div className={css.loader}>
            <Loader color="grey" size="15px" />
        </div>);

    return finalView;
};

SignInCards.propTypes = {
    filteredClassrooms: PropTypes.array,
    isClassroomsLoaded: PropTypes.bool,
    isTeachersLoaded: PropTypes.bool
};

export default styleable(css)(SignInCards);




// WEBPACK FOOTER //
// ./app/components/sign-in-cards/index.js